const ltAllowedRoutes: string[] = [
	"/lt-LT/fraud-prevention/",
	"/lt-LT/kainos/verslo-saskaita/",
	"/lt-LT/kainos/asmenine-saskaita/",
	"/lt-LT/kainos/asmenine-kortele/",
	"/lt-LT/verslui/kortele/",
	"/lt-LT/slapuku-politika/",
	"/lt-LT/privatumo-politika/",
	"/lt-LT/dokumentai/",
	"/lt-LT/bendrosios-taisykles/",
	"/lt-LT/saskaitos-sutartis/",
	"/lt-LT/saskaitos-limitai/asmeniniai/",
	"/lt-LT/saskaitos-limitai/verslui/",
	"/lt-LT/bendrosios-paskolos-sutarties-salygos/",
	"/lt-LT/pretenziju-pateikimo-ir-nagrinejimo-tvarka/",
	"/lt-LT/partnerystes-programos-taisykles/",
	"/lt-LT/mokejimo-korteles-sutartis/",
	"/lt-LT/salyginio-deponavimo-saskaitos-sutartis/",
	"/lt-LT/periodiniu-mokejimu-sutartis/",
	"/lt-LT/naudojimosi-api-sutartis/",
	"/lt-LT/depozitines-saskaitos-sutartis/",
	"/lt-LT/salyginio-deponavimo-saskaitos-sutartis/",
	"/lt-LT/periodiniu-mokejimu-sutartis/",
	"/lt-LT/kainos/verslo-saskaita/2022-07-01/",
	"/lt-LT/kainos/asmenine-saskaita/2022-07-01/",
	"/lt-LT/e-pinigines-taisykles/",
	"/lt-LT/privatumo-politika/2022-05-19/",
	"/lt-LT/saskaitos-sutartis/2022-07-28/",
	"/lt-LT/bendrosios-taisykles/2022-07-28/",
	"/lt-LT/pretenziju-pateikimo-ir-nagrinejimo-tvarka/2022-03-28/",
	"/lt-LT/mokejimo-korteles-sutartis/2022-07-28/",
	"/lt-LT/kainos/asmenine-kortele/2022-07-08/",
	"/lt-LT/verslui/kortele/2022-02-01/",
	"/lt-LT/naudojimosi-api-sutartis/2023-05-11/",
	"/lt-LT/privatumo-politika/2022-12-19/",
	"/lt-LT/kainos/verslo-saskaita/2023-08-16/",
	"/lt-LT/bendrosios-taisykles/2024-06-09/",
	"/lt-LT/saskaitos-sutartis/2024-06-09/",
	"/lt-LT/mokejimo-korteles-sutartis/2024-06-09/",
	"/lt-LT/periodiniu-mokejimu-sutartis/2024-06-09/",
	"/lt-LT/duk/kaip-veikia-visa-plus/"
];

export default ltAllowedRoutes;
